import React, { useState, useEffect } from 'react';
import { useNavigate ,Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import '../../styles/Auth.css';

function Signup() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    full_name: '',
    username: '',
    email: '',
    password: '',
    sex: '',
    date_of_birth: '',
    profile_url: '',
  });
  const [error, setError] = useState('');

  useEffect(() => {
    const selectElement = document.querySelector(".auth-select[name='sex']");
    if (selectElement && selectElement.value === "") {
      selectElement.classList.add("placeholder-shown");
    }
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleFocus = (e) => {
    e.target.classList.remove("placeholder-shown");
  };
  
  const handleBlur = (e) => {
    if (e.target.value === "") {
      e.target.classList.add("placeholder-shown");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { data } = await axiosInstance.post('/auth/signup', formData);

      // Save tokens
      localStorage.setItem('accessToken', data.accessToken);

      // Navigate to home or dashboard
      navigate('/home');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Signup failed');
    }
  };
  const [isDateFilled, setIsDateFilled] = useState(false);

  const handleDateChange = (e) => {
    const { value } = e.target;
    setIsDateFilled(!!value); // Hide placeholder if a date is selected
    // Update your form data state here
    setFormData({
      ...formData,
      date_of_birth: value,
    });
  };

  const handleDateFocus = () => {
    setIsDateFilled(true); // Hide placeholder when the input is focused
  };

  const handleDateBlur = (e) => {
    const { value } = e.target;
    setIsDateFilled(!!value); // Show placeholder if the input is empty
  };

  return (
    <div className="auth-container">
      <img src="assets/images/logo-auth.png" alt="Logo" className="auth-logo" />
      <h1>trippin</h1>
      <div className="auth-card">   
        <form onSubmit={handleSubmit}>
          <input
            className="auth-input"
            name="full_name"
            onChange={handleChange}
            placeholder="Full Name"
            required
          />
          <input
            className="auth-input"
            name="username"
            onChange={handleChange}
            placeholder="Username"
            required
          />
          <input
            className="auth-input"
            name="email"
            onChange={handleChange}
            placeholder="Email"
            type="email"
            required
          />
          <input
            className="auth-input"
            name="password"
            onChange={handleChange}
            type="password"
            placeholder="Password"
            required
          />
          <select
            className="auth-select"
            name="sex"
            value={formData.sex}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            required
          >
            <option value="" hidden>-- Select Gender --</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
          {/* <input
            className="auth-input"
            name="date_of_birth"
            type="date"
            onChange={handleChange}
            required
          /> */}
          <div className="date-input-container">
            <input
              type="date"
              className={`auth-input ${isDateFilled ? "show-date-fields" : ""}`}
              name="date_of_birth"
              onChange={handleDateChange}
              onFocus={handleDateFocus}
              onBlur={handleDateBlur}
              required
            />
            <span className={`date-placeholder ${isDateFilled ? "hidden" : ""}`}>
              -- Select Date of Birth --
            </span>
          </div>
          <button className="auth-button" type="submit">Sign Up</button>
        </form>
        <p style={{ fontSize: "17px" }}>
          already have an account? <Link to="/login" className="auth-link">Login</Link>
        </p>
        {error && <p className="auth-error">{error}</p>}
      </div>
    </div>
  );
}


export default Signup;
